<template>
  <div class="text-center mx-auto">
    <h1>Novo usuário</h1>
    <v-divider></v-divider>
    <FormUser
      :user="user"
      :is-new="true"
      @submitUser="createUser($event)"
    ></FormUser>
    <v-dialog v-model="loading" persistent fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular
            indeterminate
            color="#00aab0"
            :size="100"
            :width="10"
          >
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AdminUserService from "@/services/admin-user/admin-user.service";
import FormUser from '@/pages/admin/components/user/FormUser';
import User from '@/models/user';

const userService = new AdminUserService();

export default {
  name: 'CreateUser',
  components: { FormUser },
  data: () => ({
    user: new User(),
    loading: false,
    snackbar: false,
    snackbarText: '',
  }),
  methods: {
    showSnack(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    createUser(user) {
      this.loading = true;

      userService.createUser(user)
        .then((response) => {
          this.showSnack(response.data.message);

          this.loading = false;
          this.$router.push(`/admin/users`);
        })
        .catch((err) => {
          this.loading = false;
          this.showSnack(err?.response?.data?.message ?? 'Falha ao criar o usuário');
        });
    },
  }
};
</script>

<style scoped>

</style>
